import gsap from 'gsap';

export default function fVideo () {
    function offset(el) {
        let rect = el.getBoundingClientRect();
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }

    function fAnimateModalIn (oModal, oBackdrop, oSourceDimensions) {
        let oTimeline = new gsap.timeline();
        let iVideoWidth = (window.innerWidth * 80) / 100;
        let iVideoHeight = (iVideoWidth * 9) / 16;

        if (iVideoHeight > window.innerHeight) {
            iVideoHeight = (window.innerHeight * 80) / 100;
            iVideoWidth = (iVideoHeight * 16) / 9;
        }

        gsap.defaults({ease: 'quart.InOut'});
        oTimeline.timeScale(2);

        function fFixModal () {
            oModal.style.position = 'fixed';
            oModal.style.top = `${(window.innerHeight - (iVideoHeight)) / 2}px`;
        }

        oTimeline
        .set(oModal, {
            display: 'block',
            top: oSourceDimensions.y,
            left: oSourceDimensions.x,
            width: oSourceDimensions.width,
            height: oSourceDimensions.height,
        })
        .to(oModal, 1, {
            autoAlpha: 1,
            ease: 'quart.Linear'
        })
        .to(oModal, 1.2, {
            top: `${((window.innerHeight - (iVideoHeight)) / 2) + window.pageYOffset}px`,
            height: `${iVideoHeight}px`,
            left: '0',
            right: '0',
            margin: 'auto',
            width: `${iVideoWidth}px`,
            onComplete: fFixModal
        }, '-=0.5')
        .to(oBackdrop, 1, {
            autoAlpha: 1
        }, '-=1');
    }

    function fAnimateModalOut (oModal, oBackdrop) {
        let oTimeline = gsap.timeline();
        let oIframe = oModal.querySelector('iframe');

        gsap.defaults({ease: 'quart.InOut'});
        oTimeline.timeScale(2);

        function fDestroyModal () {
            oModal.remove();
            oBackdrop.remove();
        }

        oTimeline
        .to(oIframe, 0.8, {
            autoAlpha: 0
        })
        .to(oBackdrop, 1, {
            autoAlpha: 0
        })
        .to(oModal, .7, {
            scaleX: .8
        }, '-=0.8')
        .to(oModal, .7, {
            y: '150%',
            onComplete: fDestroyModal
        }, '-=0.4');
    }

    function fCreatePlayer (sYoutubeId) {
        let oPlayer = new YT.Player(sYoutubeId, {
            videoId: sYoutubeId,
            playerVars: {
                rel: 0,
                controls: 0,
                modestbranding: 1,
                autoplay: 1,
                showinfo: 0,
                start: 0
            }
        });
    }

    function fCreateModal (oButton) {
        // Get source and its dimensions and offset
        let oSource = oButton.parentNode.querySelector('.js-video-source');
        let sVideoUrl = oButton.getAttribute('data-video-url');

        if (!oSource || !sVideoUrl) return;

        let oSourceDimensions = {
            width: oSource.offsetWidth,
            height: oSource.offsetHeight,
            x: offset(oSource).left,
            y: offset(oSource).top
        }

        // Create a modal and backdrop
        let oModal = document.createElement('div');
        let oModalClose = document.createElement('button');
        let oVideoFrame = document.createElement('iframe');
        let oBackdrop = document.createElement('div');

        // Add modal to body
        oModal.setAttribute('class', 'modal modal--video');
        document.body.appendChild(oModal);

        // Add closer button to modal
        oModalClose.classList.add('modal__close');
        oModalClose.innerHTML = '<svg class="modal__close__icon"><use xlink:href="#close"></use></svg>';
        oModal.appendChild(oModalClose);

        // Add video frame to modal
        oVideoFrame.src = sVideoUrl;
        oModal.appendChild(oVideoFrame);

        // Add backdrop to body
        oBackdrop.classList.add('backdrop');
        document.body.appendChild(oBackdrop);

        // Animate them
        fAnimateModalIn(oModal, oBackdrop, oSourceDimensions);

        // Add event listeners to backdrop & closer to close modal
        window.addEventListener('click', function(event) {
            if (event.target.closest('.backdrop') || event.target.closest('.modal__close')) {
                fAnimateModalOut(oModal, oBackdrop);
            }
        });
    }

    window.addEventListener('click', function (event) {
        if (event.target.closest('.js-video-open')) {
            fCreateModal(event.target.closest('.js-video-open'));
        }
    });
}
